import { PriceDisplayStyled } from 'pricing-pages-ui-components/price/PriceDisplayStyled';
import SuiteProductLevelIdentifiersMap from 'pricing-pages-ui/constants/merchCards/SuiteProductLevelIdentifiersMap';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import { useCrmSuitePricingInfo } from './useCrmSuitePricingInfo';
import { jsx as _jsx } from "react/jsx-runtime";
export const CrmSuitePriceMerchCard = ({
  productLevel,
  showPricePerMonthPerSeat
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  const {
    pricingInfo,
    loading
  } = useCrmSuitePricingInfo({
    productLevel
  });
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [20],
    widths: ['100%'],
    children: pricingInfo && /*#__PURE__*/_jsx(PriceDisplayStyled, {
      pricingInfo: pricingInfo,
      seleniumId: SuiteProductLevelIdentifiersMap[productLevel],
      showPricePerMonthPerSeat: showPricePerMonthPerSeat,
      currencyCode: currencyCode,
      currencyCodeUnit: currencyCodeUnit
    })
  });
};
export default CrmSuitePriceMerchCard;